// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const PositionIndicator = (props: SVGProps<SVGSVGElement>) => (
	<svg width="1em" height="1em" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M8.5 48C8.5 26.185 26.185 8.5 48 8.5S87.5 26.185 87.5 48 69.815 87.5 48 87.5 8.5 69.815 8.5 48ZM36 27.904c0 1.453.682 2.722 1.73 3.617l16.906 16.02-16.652 15.777c-1.18.895-1.984 2.223-1.984 3.773C36 69.804 38.299 72 41.143 72a5.247 5.247 0 0 0 3.639-1.448l20.751-19.68C66.431 49.995 67 48.814 67 47.5c0-1.296-.56-2.455-1.434-3.328l-20.751-19.68A5.232 5.232 0 0 0 41.143 23C38.3 23 36 25.196 36 27.904Z"
			fill="#fff"
		/>
	</svg>
);
export default PositionIndicator;
